import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class MyQaReviewService {

  constructor(private httpClient: HttpClient) { }

  getMyQaReviews(includeAll: boolean): Observable<any> {
    return this.httpClient.get(ApiConstants.DocumentMyQaReviews_Api+"/"+includeAll);
  }
}
